/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InfoState {
    Pending = 1,
    Active = 2,
    Expired = 3,
}
